export default __webpack_public_path__ + "static/Toasts-90b6e824f9bf936ebf4df741cefcea92.png";